import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { IcHandHoldingUsd, IcPlus, IcFileInvoiceDollar, IcPdf, IcAt, IcExcel, IcCalc, IcMoneyBill, IcExchange, IcSave, IcCheckCircle } from "../../Icons";
import Header from "../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
  FormGroup,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import { pdfHeader, pdfFooter, pdfTableStyles } from "../../../pdfUtils";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../DataTable";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import moment from 'moment';
import { v4 as uuidv4 } from "uuid";

function ListadoAbonos() {
  const { user } = useContext(AuthContext);
  const URL_ABONOS  = process.env.REACT_APP_URL_ABONOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_CARGOS  = process.env.REACT_APP_URL_CARGOS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  let hoy = new Date()
// Obtener el primer día del mes en curso
let inicio = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
 
  let endDate   = moment(hoy).format("YYYY-MM-DD"); 
  let startDate   = moment(inicio).format("YYYY-MM-DD");

  const [abonosTiendas, setAbonosTiendas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [selectedEmpresa, setSelectedEmpresa] = useState("ExceptoSistemify");
  const [formaPago, setFormaPago] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");
  const [refreshCount,  setRefreshCount]  = useState(0);
  const [modalCreate,   setModalCreate]   = useState(false);
  const toggleCreate = () => { setModalCreate(!modalCreate); setACargos([]); setACliente(""); };
  const [aFecha,        setAFecha]        = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [aCliente,      setACliente]      = useState("");
  const [aFormaPago,    setAFormaPago]    = useState("Efectivo");
  const [aConcepto,     setAConcepto]     = useState("Abono");
  const [aCargos,       setACargos]       = useState([]);
  const [aLoading,      setALoading]      = useState(false);


  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(()=>{
    axios
      .get(`${URL_ABONOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allVentas = response.data;
        // Array para pagination
        let arrayTabla = allVentas
          .sort((a, b) => (a.idAbono < b.idAbono ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              numero: a.idAbono,
              fecha: a.fecha,
              clientes: a.clientes[0].nombre_comercial,
              idClientes: a.clientes[0]._id,
              empresa: a.clientes[0].empresa,
              formaPago: a.formaPago,
              observaciones: a.observaciones,
              importe: a.importe,
              nota: a.cargos[0].idCargo,
              aplicado: a.aplicado
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let data = Object.values(arrayTabla);

        setAbonosTiendas(data);
        setComments(data);
        //
      })
      .catch((err) => {
      });

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
      });



  }, [selectedFechaInicio, selectedFechaFin, refreshCount]); // eslint-disable-line

  // Cargar cargos pendientes al seleccionar cliente en modal
  useEffect(() => {
    if (!aCliente) return setACargos([]);
    setALoading(true);
    axios.get(`${URL_CARGOS}/cliente/${aCliente}`, {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    }).then((r) => {
      const pendientes = (r.data || [])
        .filter((c) => (c.saldo || 0) > 0)
        .map((c) => ({ _id: c._id, idCargo: c.idCargo, fecha: c.fecha, descripcion: c.descripcion, saldo: c.saldo, importePago: "", observaciones: "" }));
      setACargos(pendientes);
      setALoading(false);
    }).catch(() => setALoading(false));
  }, [aCliente]); // eslint-disable-line

  function saveAbono() {
    const rows = aCargos.filter((c) => Number(c.importePago) > 0);
    if (!aCliente || !aFecha || rows.length === 0) {
      return Swal.fire({ icon: "warning", title: "Selecciona cliente e ingresa al menos un importe" });
    }
    const invalid = rows.find((c) => Number(c.importePago) > c.saldo);
    if (invalid) return Swal.fire({ icon: "warning", title: `El importe de "${invalid.descripcion}" supera el saldo pendiente` });

    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    Promise.all(rows.map((c) =>
      axios.post(URL_ABONOS, {
        fecha: aFecha, importe: Number(c.importePago), clientes: aCliente,
        cargos: c._id, formaPago: aFormaPago, concepto: aConcepto,
        observaciones: c.observaciones || "NA", aplicado: "No", comisionPagada: "No",
      }, { headers }).then(() =>
        axios.patch(`${URL_CARGOS}/${c._id}`, {
          abonos: (c.saldo - c.saldo) + Number(c.importePago), // patch handled server-side
          saldo: c.saldo - Number(c.importePago),
        }, { headers })
      )
    )).then(() => {
      setAFecha(moment(new Date()).format("YYYY-MM-DD"));
      setAFormaPago("Efectivo"); setAConcepto("Abono"); setACliente(""); setACargos([]);
      setModalCreate(false);
      setRefreshCount((p) => p + 1);
      Swal.fire({ icon: "success", title: "Abono registrado", timer: 1500, showConfirmButton: false });
    }).catch(() => Swal.fire({ icon: "error", title: "Error al guardar" }));
  }

function PDFTabla() {
  let TotalImporte = 0;

  const data = comments
    .filter(
      (comment) =>
        comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
        comment.formaPago.toLowerCase().includes(search.toLowerCase()) ||
        comment.empresa.toLowerCase().includes(search.toLowerCase()) ||
        comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
        comment.importe.toString().includes(search) ||
        comment.numero.toString().includes(search)
    )
    .sort((a, b) => (a.idAbono > b.idAbono ? 1 : -1))
    .map((a) => {
      const coincideEmpresa =
        selectedEmpresa === "" ||
        (selectedEmpresa === "ExceptoSistemify"
          ? a.empresa !== "Sistemify"
          : selectedEmpresa === a.empresa);

      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (formaPago == 0 || formaPago == a.formaPago) &&
        coincideEmpresa
      ) {
        TotalImporte += Number(a.importe) || 0;

        return [
          a.numero,
          a.fecha,
          a.clientes,
          a.empresa,
          a.formaPago,
          a.observaciones,
          "$" + new Intl.NumberFormat("en-US").format(a.importe),
        ];
      }

      return null;
    });

  const dataPDFLimpia = Object.values(data).filter((el) => el != null);

  const doc = new jsPDF("landscape");
  const startY = pdfHeader(doc, "Listado de Abonos", `${selectedFechaInicio} — ${selectedFechaFin}`);

  doc.autoTable({
    ...pdfTableStyles(),
    head: [
      [
        "Numero",
        "Fecha",
        "Cliente",
        "Empresa",
        "Forma Pago",
        "Observaciones",
        "Importe",
      ],
    ],
    body: dataPDFLimpia,
    startY,
    foot: [
      [
        "",
        "",
        "",
        "",
        "",
        "Total",
        "$" + new Intl.NumberFormat("en-US").format(TotalImporte),
      ],
    ],
    showFoot: "lastPage",
  });

  pdfFooter(doc);
  doc.save(`Abonos.pdf`);
}

function excel() {
  const dataExcel = comments
    .filter(
      (comment) =>
        comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
        comment.formaPago.toLowerCase().includes(search.toLowerCase()) ||
        comment.empresa.toLowerCase().includes(search.toLowerCase()) ||
        comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
        comment.importe.toString().includes(search) ||
        comment.numero.toString().includes(search)
    )
    .sort((a, b) => (a.idAbono > b.idAbono ? 1 : -1))
    .map((a) => {
      const coincideEmpresa =
        selectedEmpresa === "" ||
        (selectedEmpresa === "ExceptoSistemify"
          ? a.empresa !== "Sistemify"
          : selectedEmpresa === a.empresa);

      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (formaPago == 0 || formaPago == a.formaPago) &&
        coincideEmpresa
      ) {
        return {
          Numero: a.numero,
          Fecha: a.fecha,
          Cliente: a.clientes,
          Empresa: a.empresa,
          FormaPago: a.formaPago,
          Observaciones: a.observaciones,
          Importe: a.importe,
        };
      }

      return null;
    });

  const dataExcelLimpia = Object.values(dataExcel).filter((el) => el != null);

  var option = {};
  option.fileName = "ListadoAbonosTiendas";

  option.datas = [
    {
      sheetData: dataExcelLimpia,
      sheetName: "ListadoAbonosTiendas",
      sheetFilter: [
        "Numero",
        "Fecha",
        "Cliente",
        "Empresa",
        "FormaPago",
        "Observaciones",
        "Importe",
      ],
      sheetHeader: [
        "Numero",
        "Fecha",
        "Cliente",
        "Empresa",
        "FormaPago",
        "Observaciones",
        "Importe",
      ],
    },
  ];

  var toExcel = new ExportJsonExcel(option);
  toExcel.saveExcel();
}

  function enviaMail() {
    let TotalImporte= 0
    const data = comments
    .filter(
      (comment) =>
        comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
        comment.formaPago.toLowerCase().includes(search.toLowerCase()) ||
        comment.empresa.toLowerCase().includes(search.toLowerCase()) ||
        comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
        comment.importe.toString().includes(search) ||
        comment.numero.toString().includes(search) 
    )
    .sort((a, b) => (a.idAbono > b.idAbono ? 1 : -1))
    .map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (formaPago == 0 || formaPago == a.formaPago)
      ) {
        TotalImporte = TotalImporte + a.importe
        return [
          a.numero,
          a.fecha,
          a.clientes,
          a.empresa,
          a.formaPago,
          a.observaciones,
          "$" + new Intl.NumberFormat("en-US").format(a.importe),
        ];
      }
    });

    const dataPDF = Object.values(data);

    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });


    const doc = new jsPDF("landscape");
    const startY = pdfHeader(doc, "Listado de Abonos", `${selectedFechaInicio} — ${selectedFechaFin}`);
    doc.autoTable({
      ...pdfTableStyles(),
      head: [
        [
          "Numero",
          "Fecha",
          "Cliente",
          "Empresa",
          "Forma Pago",
          "Observaciones",
          "Importe",
        ],
      ],
      body: dataPDFLimpia,
      startY,
      foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "Total",
          "$" +new Intl.NumberFormat("en-US").format(TotalImporte)
        ]
      ]
    });

    pdfFooter(doc);
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Abonos",
          email: mailTo,
          fileName: "ListadoAbonos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Abonos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
      });
  }

 

  async function PDFOC(
    fecha,
    clientes,
    importe,
    nota,
    formaPago,
    observaciones,
    numero
  ) {

       
        const doc = new jsPDF();
        const startY = pdfHeader(doc, "Recibo de Abono");
        // doc.text(`${process.env.REACT_APP_NOMBRE_INSTITUCION}`, 110, 53);
        doc.text(`___________________`, 77, 80);
        doc.text(`Firma`, 98, 90);

        doc.autoTable({
          ...pdfTableStyles(),
          head: [
            [
              "Fecha",
              "Cliente",
              "Forma Pago",
              "Importe",
            ],
          ],
          body: [[
            fecha,
            clientes,
            formaPago,
            "$" + new Intl.NumberFormat("en-US").format(importe)
          ]],
          startY,

        });

        pdfFooter(doc);
        doc.save(`Abono.pdf`);

  }



  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: false },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Empresa", field: "empresa", sortable: true },
    { name: "Forma Pago", field: "formaPago", sortable: true },
    { name: "Observaciones", field: "observaciones", sortable: true },
    { name: "Importe", field: "importe", sortable: true },
    { name: "Recibo", field: "recibo", sortable: false },
    { name: "Aplicado", field: "aplicado", sortable: false },
  ];

  const summaryStats = useMemo(() => {
    const fmtI = (v) => "$" + new Intl.NumberFormat("en-US").format(Math.round(v || 0));
    const base  = comments.filter((c) => c.empresa !== "Sistemify");
    const total = base.reduce((s, a) => s + (Number(a.importe) || 0), 0);
    const efectivo      = base.filter((a) => a.formaPago === "Efectivo").reduce((s, a) => s + (Number(a.importe) || 0), 0);
    const transferencia = base.filter((a) => (a.formaPago || "").toLowerCase().includes("transfer")).reduce((s, a) => s + (Number(a.importe) || 0), 0);
    const otros         = total - efectivo - transferencia;
    return {
      count:        base.length,
      total:        fmtI(total),
      promedio:     fmtI(base.length > 0 ? total / base.length : 0),
      efectivo:     fmtI(efectivo),
      transferencia: fmtI(transferencia),
      otros:        fmtI(otros > 0 ? otros : 0),
    };
  }, [comments]);

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.formaPago.toLowerCase().includes(search.toLowerCase()) ||
          comment.empresa.toLowerCase().includes(search.toLowerCase()) ||
          comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.importe.toString().includes(search) ||
          comment.numero.toString().includes(search) 
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }
    if (formaPago) {
      computedComments = computedComments.filter((e) =>
        e.formaPago.includes(formaPago)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }
     if (selectedEmpresa === "ExceptoSistemify") {
  computedComments = computedComments.filter(
    (e) => e.empresa !== "Sistemify"
  );
} else if (selectedEmpresa) {
  computedComments = computedComments.filter(
    (e) => e.empresa === selectedEmpresa
  );
}

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "importe" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "importe" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "importe" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedFechaInicio,
    selectedFechaFin,
    formaPago,
    selectedEmpresa
  ]);

  function aplicar(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se va a aplicar!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, aplicar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_ABONOS}/${id}`,
            {
              aplicado: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Se aplico",
              showConfirmButton: false,
              timer: 2000,
            });
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
          });
      }
    });
  }
 
  let totalTabla = 0;
  return (
    <>
      <Header />
      {user.menu_usuarios ? (
        <div className="card container col-sm-11">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcHandHoldingUsd style={{ marginRight: 8, color: "#10b981" }} />
                Abonos
              </h3>
              <p className="page-subtitle">Registro de pagos recibidos de clientes</p>
            </div>
            <div className="page-actions">
              <Button size="sm" color="success" onClick={toggleCreate}>
                <IcPlus style={{ marginRight: 6 }} />
                Nuevo Abono
              </Button>
              <Button size="sm" color="info" href="/AnticiposClientes" style={{ marginLeft: 6 }}>
                <IcFileInvoiceDollar style={{ marginRight: 6 }} />
                Anticipos
              </Button>
              <ButtonGroup>
                <Button size="sm" color="danger" onClick={PDFTabla}>PDF <IcPdf /></Button>
                <Button size="sm" color="info" onClick={toggleMail}>eMail <IcAt /></Button>
                <Button size="sm" color="primary" onClick={excel}>Excel <IcExcel /></Button>
              </ButtonGroup>
            </div>
          </div>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Abonos</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>

          {/* ── Summary cards ──────────────────────────────────────────── */}
          <div className="row mb-3 mt-1">
            {[
              { label: "Total cobrado",    value: summaryStats.total,        sub: `${summaryStats.count} abonos`,          icon: <IcHandHoldingUsd />, color: "#10b981", bg: "#f0fdf4" },
              { label: "Promedio / abono", value: summaryStats.promedio,     sub: "Importe medio",                        icon: <IcCalc />,          color: "#8b5cf6", bg: "#f5f3ff" },
              { label: "Efectivo",         value: summaryStats.efectivo,     sub: "Pagos en efectivo",                    icon: <IcMoneyBill />,     color: "#3b82f6", bg: "#eff6ff" },
              { label: "Transferencia",    value: summaryStats.transferencia, sub: "Pagos por transferencia",              icon: <IcExchange />,      color: "#f59e0b", bg: "#fffbeb" },
            ].map((card, i) => (
              <div key={i} className="col-6 col-md-3 mb-2">
                <div style={{ background: "#fff", borderRadius: 14, padding: "16px 18px", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", borderTop: `3px solid ${card.color}`, display: "flex", alignItems: "center", gap: 14, height: "100%" }}>
                  <div style={{ width: 46, height: 46, borderRadius: 12, background: card.bg, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", color: card.color }}>
                    {card.icon}
                  </div>
                  <div>
                    <div style={{ fontSize: "1.1rem", fontWeight: 800, color: "#0f172a", lineHeight: 1 }}>{card.value}</div>
                    <div style={{ fontSize: "0.67rem", fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 4 }}>{card.label}</div>
                    <div style={{ fontSize: "0.72rem", color: card.color, fontWeight: 600, marginTop: 2 }}>{card.sub}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <div className="filter-bar">
            <div>
              <Label>Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </div>
            <div>
              <Label>Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </div>
          </div>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {clientes
                  .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
              </td>
             
            <td>
              <Input
                  bsSize="sm"
                  type="select"
                  value={selectedEmpresa}
                  required
                  onChange={(e) => {
                    setSelectedEmpresa(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="ExceptoSistemify">Excepto Sistemify</option>
                  <option value="Lynqro">Lynqro</option>
                  <option value="Lynqro 2">Lynqro 2</option>
                  <option value="Sistemify">Sistemify</option>
                </Input>
            </td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                      type="select"
                      bsSize="sm"
                      value={formaPago}
                      onChange={(e) => {
                        setFormaPago(e.target.value);
                      }}
                    >
                      <option value="">Selecciona</option>
                      <option value="Efectivo">Efectivo</option>
                      <option value="Transfer">Transfer</option>
                      <option value="TDC">TDC</option>
                    </Input>
              </td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                      totalTabla = totalTabla + a.importe;
                {
                  return (
                    <tr>
                      <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.clientes}</td>
                      <td>{a.empresa}</td>
                      <td>{a.formaPago}</td>
                      <td>{a.observaciones}</td>
                      <td>{"$" + new Intl.NumberFormat("en-US").format(a.importe)}</td>
                      <td>
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.fecha,
                                  a.clientes,
                                  a.importe,
                                  a.nota,
                                  a.formaPago,
                                  a.observaciones,
                                  a.numero
                                )
                              }
                            >
                              <IcPdf />
                            </Button>
                        
                      </td>
                      <td>
                            {
                              a.aplicado == "No"?(
                                <Button color="primary" onClick={e=>{aplicar(a._id)}} size="sm">
                                <IcCheckCircle />
                              </Button>
                              ):undefined
                            }
                          </td>
                    
                    </tr>
                    
                  );
                }
              })}
                      <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="negrita" align="center">
                        TOTAL
                      </td>
                      <td className="negrita">
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2, roundingIncrement: 5}).format(totalTabla)}
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

     
      {/* ── Modal Nuevo Abono ────────────────────────────────────────── */}
      <Modal size="lg" isOpen={modalCreate} toggle={toggleCreate}>
        <ModalHeader toggle={toggleCreate}>
          <IcHandHoldingUsd style={{ marginRight: 8, color: "#10b981" }} />
          Nuevo Abono
        </ModalHeader>
        <ModalBody>
          <div className="row mb-3">
            <div className="col-md-3">
              <FormGroup>
                <Label>Fecha</Label>
                <Input bsSize="sm" type="date" value={aFecha} onChange={(e) => setAFecha(e.target.value)} />
              </FormGroup>
            </div>
            <div className="col-md-3">
              <FormGroup>
                <Label>Forma de Pago</Label>
                <Input type="select" value={aFormaPago} onChange={(e) => setAFormaPago(e.target.value)}
                  style={{ height: 31, fontSize: "0.875rem", padding: "0.25rem 0.5rem", color: "#0f172a" }}>
                  <option value="Efectivo">Efectivo</option>
                  <option value="Transfer">Transfer</option>
                  <option value="TDC">TDC</option>
                  <option value="Bonificacion">Bonificación</option>
                </Input>
              </FormGroup>
            </div>
            <div className="col-md-3">
              <FormGroup>
                <Label>Concepto</Label>
                <Input type="select" value={aConcepto} onChange={(e) => setAConcepto(e.target.value)}
                  style={{ height: 31, fontSize: "0.875rem", padding: "0.25rem 0.5rem", color: "#0f172a" }}>
                  <option value="Abono">Abono</option>
                  <option value="Bonificacion">Bonificación</option>
                </Input>
              </FormGroup>
            </div>
            <div className="col-md-3">
              <FormGroup>
                <Label>Cliente <span style={{ color: "#ef4444" }}>*</span></Label>
                <Input type="select" value={aCliente} onChange={(e) => setACliente(e.target.value)} required
                  style={{ height: 31, fontSize: "0.875rem", padding: "0.25rem 0.5rem", color: "#0f172a" }}>
                  <option value="">Selecciona</option>
                  {clientes.filter((c) => c.is_active === "Si").sort((a, b) => a.nombre_comercial > b.nombre_comercial ? 1 : -1).map((c) => (
                    <option key={c._id} value={c._id}>{c.nombre_comercial}</option>
                  ))}
                </Input>
              </FormGroup>
            </div>
          </div>

          {aLoading && (
            <div style={{ textAlign: "center", padding: "20px 0", color: "#94a3b8" }}>
              <Spinner size="sm" style={{ color: "#10b981" }} /> Cargando notas pendientes…
            </div>
          )}

          {!aLoading && aCliente && aCargos.length === 0 && (
            <div style={{ textAlign: "center", padding: "16px 0", color: "#94a3b8", fontSize: "0.82rem" }}>
              🎉 Este cliente no tiene saldo pendiente
            </div>
          )}

          {!aLoading && aCargos.length > 0 && (
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.8rem" }}>
              <thead>
                <tr style={{ borderBottom: "2px solid #f1f5f9" }}>
                  {["Fecha","Descripción","Saldo","Importe a pagar","Observaciones"].map((h) => (
                    <th key={h} style={{ padding: "6px 10px", color: "#64748b", fontWeight: 700, fontSize: "0.7rem", textTransform: "uppercase" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {aCargos.map((c, i) => (
                  <tr key={c._id} style={{ borderBottom: "1px solid #f8fafc" }}>
                    <td style={{ padding: "8px 10px", color: "#64748b", whiteSpace: "nowrap" }}>{c.fecha}</td>
                    <td style={{ padding: "8px 10px", color: "#334155" }}>{c.descripcion}</td>
                    <td style={{ padding: "8px 10px", color: "#f59e0b", fontWeight: 700 }}>
                      ${new Intl.NumberFormat("en-US").format(c.saldo)}
                    </td>
                    <td style={{ padding: "8px 10px" }}>
                      <Input bsSize="sm" type="number" min="0" step="any" style={{ maxWidth: 130 }}
                        value={c.importePago}
                        onChange={(e) => {
                          const updated = [...aCargos];
                          updated[i] = { ...updated[i], importePago: e.target.value };
                          setACargos(updated);
                        }} />
                    </td>
                    <td style={{ padding: "8px 10px" }}>
                      <Input bsSize="sm" type="text" style={{ maxWidth: 200 }}
                        value={c.observaciones}
                        onChange={(e) => {
                          const updated = [...aCargos];
                          updated[i] = { ...updated[i], observaciones: e.target.value };
                          setACargos(updated);
                        }} />
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr style={{ borderTop: "2px solid #e2e8f0", background: "#f8fafc" }}>
                  <td colSpan={3} style={{ padding: "8px 10px", fontWeight: 700, color: "#475569", fontSize: "0.72rem" }}>TOTAL A PAGAR</td>
                  <td style={{ padding: "8px 10px", fontWeight: 800, color: "#10b981" }}>
                    ${new Intl.NumberFormat("en-US").format(aCargos.reduce((s, c) => s + (Number(c.importePago) || 0), 0))}
                  </td>
                  <td />
                </tr>
              </tfoot>
            </table>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={saveAbono} disabled={aCargos.every((c) => !c.importePago)}>
            <IcSave style={{ marginRight: 6 }} /> Guardar
          </Button>
          <Button color="secondary" onClick={toggleCreate}>Cancelar</Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoAbonos;
